/** @format */

import Swiper from 'swiper';
import Navigation from 'swiper/modules/navigation';

const imageCarousel = () => ({
  swiper: null,

  init() {
    this.swiper = new Swiper(this.$refs.swiper, {
      slidesPerView: 1,
      loop: true,
      centeredSlides: true,
      breakpoints: {
        750: {
          slidesPerView: 3,
        },
      },
      modules: [Navigation],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  },

  destroy() {
    this.swiper.destroy();
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.data('imageCarousel', imageCarousel);
});
